module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.events) ? _c('section', {
    staticClass: "grid grid--calendar",
    class: _vm.classes
  }, [(_vm.renderColumns) ? _vm._l((_vm.columns), function(column, index) {
    return _c('div', {
      staticClass: "grid__column",
      style: (_vm.getDelay(index))
    }, _vm._l((column), function(evt) {
      return _c('event-preview', {
        key: evt,
        staticClass: "grid__item",
        attrs: {
          "evt": evt,
          "params": _vm.params
        }
      })
    }))
  }) : _vm._l((_vm.events), function(evt, index) {
    return _c('event-preview', {
      key: evt,
      staticClass: "grid__item",
      style: (_vm.getDelay(index)),
      attrs: {
        "evt": evt,
        "params": _vm.params
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6aaff0cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/events/EventGrid.vue
// module id = 640
// module chunks = 1